import { CommonModule } from '@angular/common';
import { Component, Input, forwardRef, HostBinding } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'websilk-select-field',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WebsilkSelectField),
      multi: true
    }
  ],
  templateUrl: './ws-select-field.component.html'
})
export class WebsilkSelectField implements ControlValueAccessor {
  @HostBinding('attr.id')
  externalId = '';

  @Input() id: string;
  @Input('value') _value;
  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    // if (this._value == undefined) {
    //   return 'false';
    // }
    if (typeof this._value === 'boolean') {
      return this._value.toString();
    }

    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  @Input() inlineLabelClass: string = 'col-md-3 text-md-right';
  @Input() inlineFieldClass: string = 'col-md-9';
  @Input() errorText: string = '';
  @Input() labelText: string = '';
  @Input() idKey: string = '';
  @Input() disabled: boolean = false;
  @Input() descKey: string = '';
  @Input() bindItems: Array<any> = [];
  @Input('required') _required = 'false';
  get required() {
    return (this._required == 'true');
  }

  @Input('displayInline') _displayInline = 'true';
  get displayInline() {
    return (this._displayInline == 'true');
  }

  @Input('placeholderText') _placeholderText = null;
  get placeHolderText() {
    return this._placeholderText;
  }

  constructor() { }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  getItemValue(item: object, prop: string) {
    var val = '';
    debugger;
    if (prop.indexOf('+') > -1) {
      var arr = prop.split('+');
      for (let i = 0; i < arr.length; i++) {
        val = val + ' ' + item[arr[i]];
      }
    } else {
      val = item[prop];
    }
    return val;
  }
}



